import chroma from "chroma-js";
import { isColorDark } from ".";

export function defineCssVars(
  primaryColorStr: string,
  highlightColorStr: string,
  isDarkMode: boolean
): void {
  const primaryColor = chroma(primaryColorStr);
  //const secondaryColor = chroma(highlightColorStr);
  const isPrimaryColorDark = isColorDark(primaryColor.hex());
  const rootEl = document.documentElement;
  rootEl.style.setProperty(
    "--okhi-spinner-color",
    isPrimaryColorDark ? primaryColorStr : highlightColorStr
  );
  rootEl.style.setProperty(
    "--okhi-custom-radio-color",
    (isPrimaryColorDark && !isDarkMode) || (!isPrimaryColorDark && isDarkMode)
      ? primaryColorStr
      : highlightColorStr
  );
}
